import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';

@Component({
  selector: 'app-loader',
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
  standalone:true
})
export class LoaderComponent {
  loading$: any;
  constructor(private authService: AuthService) {
    this.loading$ = this.authService.loading$;
  }
}
